$brbr_brbr_app $mol_book2_catalog
	menu_title \Моя компания
	Menu_logo <= Logo2 $brbr_brbr_logo
	param \page
	plugins /
		<= Theme $mol_theme_auto
	menu_tools /
		<= Sources $mol_link_source
			uri \https://github.com/Lyumih/richtemplate
		<= Lighter $mol_lights_toggle
	menu_foot /
		<= Logout_button $brbr_brbr_button
			title \Выйти
	Spread_default 
		<= Docs $mol_page 
			body / 
				<= Docs_uri $mol_link 
					title \Демонстрации
					uri \http://localhost:9080/brbr/brbr/docs/-/test.html
	spreads *
		hello <= Page1 $mol_page
			title \Привет $mol!
			body /
				<= Hello $mol_text text \
					\# Привет https://mol.hyoo.ru/#!section=docs/=6leyma_5ks814]
					\Инструкция по шаблону читай на https://github.com/Lyumih/richtemplate
			
				
